export const formatPrice = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const price = typeof value === 'string' ? Number(value.replace(',', '.').replace(/\s/g, '')) : value;

  if (!Number.isFinite(price)) {
    return '';
  }

  return (
    new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    })
      .format(price)
      // Intl может вставлять неразрывный пробел — заменяем обычным.
      .replace(/\u00A0|\u202F/g, ' ')
  );
};
